import React from 'react'
import RegistrationLayout from './../../_global/RegistrationLayout'
import CreateAccount from './CreateAccount'

interface RegistrationComponentProps {
  history: any
  queryParamsWithSource?: boolean
}

const Registration = ({ history, queryParamsWithSource }: RegistrationComponentProps) => {
  return (
    <RegistrationLayout>
      <CreateAccount history={history} isFurloughReferral={!!queryParamsWithSource} />
    </RegistrationLayout>
  )
}

export default Registration
